import styles from '../singleMiniFeedback.module.scss';
import {Tag, Button as AntButton} from 'antd';

export const MiniFeedbackHeader = ({
  title,
  isActive,
  description,
  onAddQuestion,
}) => {
  return (
    <div className={styles.header}>
      <div className={styles.titleSection}>
        <div className={styles.titleRow}>
          <h2>{title}</h2>
          <Tag
            color={isActive ? '#86efac' : '#fca5a5'}
            style={{
              color: '#166534',
              marginLeft: '12px',
              border: 'none',
              borderRadius: '12px',
              fontWeight: 'bold',
            }}>
            {isActive ? 'Active' : 'Inactive'}
          </Tag>
        </div>
        <p className={styles.description}>{description}</p>
      </div>
      <div className={styles.actionButtons}>
        <AntButton
          type="primary"
          shape="round"
          className={styles.primaryBtn}
          style={{marginLeft: '12px'}}
          onClick={onAddQuestion}>
          Add Questions
        </AntButton>
      </div>
    </div>
  );
};
